import classNames from 'classnames';
import React, { FC, useState } from 'react';
import { OutsideClickHandler } from 'components/atoms/outside-click-handler';
import { ClassNamePropsWithChildren } from 'components/ozone-component';
import styles from './list-item.module.css';

interface ListItemProps extends ClassNamePropsWithChildren {
  content: React.ReactNode;
  contentClassName?: string;
  overlay: React.ReactNode;
  overlayClassName?: string;
  isInputActive?: boolean;
}
export const ListItem: FC<ListItemProps> = (props) => {
  const {
    className,
    content,
    contentClassName,
    overlay,
    overlayClassName,
    isInputActive,
  } = props;

  const [overlayActive, setOverlayActive] = useState(false);

  return (
    <div className={classNames(styles.wrapper, className)}>
      <div className={classNames(styles.content, contentClassName)}>
        {content}
        {overlay && (
          <div
            role="presentation"
            className={classNames(styles.content_overlay, overlayClassName, {
              [styles.input_active]: isInputActive,
              [styles.active]: overlayActive,
            })}
            onClick={() => setOverlayActive(true)}
          >
            <OutsideClickHandler onOutsideClick={() => setOverlayActive(false)}>
              {overlay}
            </OutsideClickHandler>
          </div>
        )}
      </div>
    </div>
  );
};
